import store from '../../../../Vue/Modules/Auth/Custom/Site/store';
import Vue from 'vue'
// views
import SiteAuthIndex from '../../../../Vue/Modules/Auth/Custom/Site/SiteAuthIndex';

const el = document.querySelector('div#auth-module');

let props = {
    captcha: el.dataset['captcha']
}
window.site_auth_vue_instance = new Vue({
    store,
    el: 'div#auth-module',
    render: h => h(SiteAuthIndex, { props: props} )
});